import { el } from 'redom';

import ProducerMode from './producer-mode';
import ViewerMode from './viewer-mode';

class CreatedView {

  constructor(currentUserId, meeting) {

    this.meeting = meeting;

    this.attendeeMode = null;

    if (currentUserId === meeting.ownerId) {
      this.attendeeMode = new ProducerMode(this.meeting, this.onLiveModeActivated.bind(this));
    } else {
      this.attendeeMode = new ViewerMode();
    }

    this.el = el('.created-view-main', [this.attendeeMode]);

  }

  onLiveModeActivated() {

    const meetingWentLive = new CustomEvent('meeting-went-live');

    this.el.dispatchEvent(meetingWentLive);

  }

}

export default CreatedView;